import { BlobServiceClient } from '@azure/storage-blob';
import { PeriodicTaskBase } from '#common/util';
import { constructBaseUrl } from './endpoint';
import { retryOptionsFactory } from './retry-options';
const MINUTE = 60 * 1_000;
const DEFAULT_SAS_TOKEN_REFRESH_INTERVAL = 10 * MINUTE;
export class SasTokenBlobClientProvider extends PeriodicTaskBase {
    azureProviderConfig;
    retryOptions;
    blobServiceClient;
    currentSasToken;
    constructor(azureProviderConfig, retryOptions) {
        super('SasTokenBlobClientProvider', azureProviderConfig.sasContext.refreshInterval || DEFAULT_SAS_TOKEN_REFRESH_INTERVAL);
        this.azureProviderConfig = azureProviderConfig;
        this.retryOptions = retryOptions;
    }
    async setUp() {
        await this.refreshBlobServiceClient();
        this.start();
    }
    getClient() {
        return this.blobServiceClient;
    }
    async execute() {
        await this.refreshBlobServiceClient();
    }
    onError(_err) {
        this.log.warn('Failed to refresh SAS token');
    }
    createBlobServiceClient(sasConfig) {
        const baseUrl = constructBaseUrl(sasConfig.accessKey, this.azureProviderConfig.httpScheme, this.azureProviderConfig.endpointSuffix);
        const url = `${baseUrl}?${sasConfig.sasToken}`;
        return new BlobServiceClient(url, undefined, {
            retryOptions: retryOptionsFactory(this.retryOptions.initialDelay),
        });
    }
    async refreshBlobServiceClient() {
        const sasConfig = await this.azureProviderConfig.sasContext.sasConfigFetcher.fetchSasConfig();
        if (this.currentSasToken === sasConfig.sasToken) {
            return;
        }
        this.currentSasToken = sasConfig.sasToken;
        this.blobServiceClient = this.createBlobServiceClient(sasConfig);
    }
}
